<template>
    <div>
        <protokol-invalid-feedback :errors="validator.fieldErrors('sef.api_key')">
            <b-form-group label="SEF API kjuč">
                <b-input type="password" v-model="providers.invoices.sef.api_key" />
            </b-form-group>
        </protokol-invalid-feedback>

        <b-row>
            <b-col cols="6">
                <b-form-group label="PIB">
                    <b-form-input v-model="vatNumber" :state="vatNumberState" aria-describedby="vat-number-error" />
                    <b-form-invalid-feedback id="vat-number-error">
                        {{ errors.vat_number }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="Matični broj">
                    <b-form-input v-model="mainId" :state="mainIdState" aria-describedby="main-id-error" />
                    <b-form-invalid-feedback id="main-id-error">
                        {{ errors.main_id }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <protokol-invalid-feedback :errors="validator.fieldErrors('company.name')">
            <b-form-group label="Pun naziv">
                <b-form-input v-model="company.name" />
            </b-form-group>
        </protokol-invalid-feedback>
        <protokol-invalid-feedback :errors="validator.fieldErrors('company.address')">
            <b-form-group label="Adresa">
                <b-form-input v-model="company.address" />
            </b-form-group>
        </protokol-invalid-feedback>
        <protokol-invalid-feedback :errors="validator.fieldErrors('company.city')">
            <b-form-group label="Grad">
                <b-form-input v-model="company.city" />
            </b-form-group>
        </protokol-invalid-feedback>
        <protokol-invalid-feedback :errors="validator.fieldErrors('company.bankAccount')">
            <b-form-group label="Bankovni račun">
                <b-form-input v-model="company.bankAccount" />
            </b-form-group>
        </protokol-invalid-feedback>
        <b-form-group label="IBAN">
            <b-form-input v-model="company.iban" />
        </b-form-group>
        <protokol-invalid-feedback :errors="validator.fieldErrors('company.email')">
            <b-form-group label="Email">
                <b-form-input type="email" v-model="company.email" />
            </b-form-group>
        </protokol-invalid-feedback>

        <b-form-group label="Da li ste u sistemu PDV-a?">
            <b-form-checkbox v-model="company.pdv" switch />

            <template v-if="!company.pdv">
                <b-form-select class="mt-3" v-model="company.taxExemption.reasonCode" placeholder="Šifra osnova"
                    :options="taxExemptionOptions" />
                <b-form-input v-model="company.taxExemption.reason" placeholder="Broj odluke" autocomplete="off" />
            </template>
        </b-form-group>

        <b-form-group>
            <b-row v-if="!user.id">
                <b-col cols="12"><b-button variant="success" @click="attemptSave" block :disabled="!validator.pass()">{{ $t('save') }}</b-button></b-col>
            </b-row>

            <b-row v-else>
                <b-col cols="10"><b-button variant="success" @click="attemptSave" block :disabled="!validator.pass()">{{ $t('save') }}</b-button></b-col>
                <b-col cols="2"><b-button variant="danger" @click="remove" block ><b-icon icon='trash' /></b-button></b-col>
            </b-row>
        </b-form-group>
    </div>
</template>


<script>
import Form from './Form'
export default {
    name: 'InvoicingForm',
    components: {
        Form
    },

    props: {
        user: {
            type: Object
        }
    },
    
    watch: {
        company: {
            handler: function () {
                this.validator.revalidate()
            },

            deep: true
        },

        providers: {
            handler: function () {
                this.validator.revalidate()
            },

            deep: true
        },
    },

    data: function () {
        return {
            users: null,

            providers: {
                invoices: {
                    sef: {
                        api_key: null
                    }
                }
            },

            company: {
                vatNumber: '',
                mainId: '',
                name: '',
                address: '',
                city: '',
                bankAccount: '',
                iban: '',
                email: '',
                taxExemption: {
                    reasonCode: null,
                    reason: null
                }
            },

            taxExemptionOptions: ['PDV-RS-33', 'PDV-RS-35-7'],

            errors: {
                vat_number: null,
                main_id: null,
                email: null
            },

            validator: this.$validator()
        }
    },

    methods: {
        attemptSave() {
            if (this.user.id) {
                this.save()
            } else {
                this.register()
            }
        },

        register() {
            this.$integrationApi.post(`/karadjordje/invoices/user/register`, { providers: this.providers, company: this.company }
            ).then(resp => {
                this.$bvToast.toast(this.$t('success'), {
                    variant: 'success',
                    title: "Success"
                })

                this.$emit('registered', resp.data)
            }).catch(err => {
                console.error(err)
                
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger',
                    title: "Error"
                })

                this.$emit('error')
            })
        },

        save() {
            this.$integrationApi.patch(`/karadjordje/invoices/user/${this.user.id}`, 
                { 
                    reference: {
                        project_uuid: this.$store.getters.getCurrentProject.uuid
                    },

                    data: {
                        providers: this.providers, 
                        company: this.company
                    }
                }
            ).then(resp => {
                this.$bvToast.toast(this.$t('saved'), {
                    variant: 'success',
                    title: "Success"
                })

                this.$emit('success')
            }).catch(err => {
                console.error(err)

                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger',
                    title: "Error"
                })

                this.$emit('error')
            })
        },

        async remove() {
            const confirm = await this.$mainDialog.msgBoxConfirm("Are you sure?")
            if (!confirm) return

            this.$integrationApi.delete(`/karadjordje/invoices/user/${this.user.id}`, {
                data: {
                    reference: {
                        project_uuid: this.$store.getters.getCurrentProject.uuid
                    },
                }
            }).then(resp => {
                this.$bvToast.toast(this.$t('saved'), {
                    variant: 'success',
                    title: "Success"
                })

                this.$emit('removed', this.user.id)
            }).catch(err => {
                console.error(err)

                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger',
                    title: "Error"
                })

                this.$emit('error')
            })
        },

        companySelected(company) {
            if (!company) return

            this.company.mainId = company.mb
            this.company.name = company.name
            this.company.address = company.address
            this.company.city = company.municipality

            let bank = company.banks.find(b => {
                return b.status
            })

            this.company.bankAccount = bank.number
        },

        searchCompany(vat) {
            const popup = this.$loadingPopup()

            this.$integrationApi.get('/karadjordje/services/nbs/search', {
                params: {
                    vatNumber: vat
                }
            }).then(resp => {
                this.companySelected(resp.data)
            }).catch(err => {
                this.$bvToast.toast('Nismo uspeli da nadjemo kompaniju sa tim poreskim brojem, molimo unesite ručno', {
                    variant: 'danger',
                    title: 'Greška'
                })
            }).finally(() => {
                popup.hide()
            })
        },
    },

    computed: {
        vatNumber: {
            get() {
                if (this.company.vatNumber.length < 9) {
                    this.errors.vat_number = "PIB moze da sadrži minimalno 9 karaktera."
                }

                return this.company.vatNumber
            },

            set(v) {
                if (v.length > 9) {
                    this.errors.vat_number = "PIB moze da sadrži maksimalno 9 karaktera."
                }

                this.company.vatNumber = v

                if (v.length == 9) {
                    this.searchCompany(v)
                }
            }
        },

        vatNumberState() {
            if (this.company.vatNumber.length < 9) {
                return false
            }

            if (this.company.vatNumber.length > 9) {
                return false
            }

            this.errors.vatNumber = null

            return true
        },

        mainId: {
            get() {
                if (this.company.mainId.length < 8) {
                    this.errors.mainId = "MB moze da sadrži minimalno 8 karaktera."
                }

                return this.company.mainId
            },

            set(v) {
                if (v.length > 8) {
                    this.errors.mainId = "MB moze da sadrži maksimalno 8 karaktera."
                }

                this.company.mainId = v
            }
        },

        mainIdState() {
            if (this.company.mainId.length < 8) {
                return false
            }

            if (this.company.mainId.length > 8) {
                return false
            }

            this.errors.mainId = null

            return true
        }
    },

    mounted() {
        const { providers = {}, company = {} } = this.user || {}

        this.providers = Object.assign({}, this.providers, providers)
        this.company = Object.assign({}, this.company, company)

        this.validator.validate({
            providers: this.providers,
            company: this.company
        }, {
            providers: (model, errors) => {
                if (!model.providers.invoices.sef.api_key) errors.add('sef.api_key', ["Polje je obavezno"])
            },

            company: (model, errors) => {
                if (!model.company.name) errors.add('company.name', ["Polje je obavezno"])
                if (!model.company.address) errors.add('company.address', ["Polje je obavezno"])
                if (!model.company.city) errors.add('company.city', ["Polje je obavezno"])
                if (!model.company.email) errors.add('company.email', ["Polje je obavezno"])
                if (!model.company.bankAccount) errors.add('company.bankAccount', ["Polje je obavezno"])
            }
        })

        this.$emit("change", this.validator.pass(), {
            providers: this.providers,
            company: this.company
        })
    }
}
</script>